import { Outlet } from "react-router";
import NavItemsPublic from "./NavItemsPublic.json"
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";

export default function PublicPageLayout() {
    return <>
        {/* The navbar is position:fixed and 60px tall, so this only reserves
            its height in flow. The old inline teal 80px block left a 20px
            strip under the bar and pushed 100vh pages past the viewport. */}
        <div style={{height: '60px'}} aria-hidden='true' />
        <Navbar items={NavItemsPublic}/>
        <Outlet/>
        <Footer/>
    </>;
}